export enum DateRange {
  Today = 'Today',
  Last = 'Last',
  Current = 'Current',
  Previous = 'Previous',
  OneRollingYear = 'OneRollingYear',
  CustomRange = 'CustomRange'
}
